import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import styles from './Comment.module.scss';

//components
import ClippedImage from 'common/components/ClippedImage/ClippedImage';

export default class CommentComponent extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  };

  render() {
    const { text, name, position, url } = this.props;
    return (
      <div className={styles.CommentComponent}>
        <div className={styles.Image}>
          <ClippedImage
            id="1"
            width={86}
            height={101}
            borderWidth={'1'}
            url={url}
          />
          <ClippedImage
            id="2"
            width={58}
            height={69}
            borderWidth={'1'}
            url={url}
          />
        </div>
        <div className={styles.Quote}>
          <h2 className={styles.Text}>{text}</h2>
        </div>
        <div className={styles.Footer}>
          <span className={styles.Line} />
          <div className={styles.Signature}>
            <h3 className={styles.Name}>{name}</h3>
            <p className={styles.Position}>{position}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Comment/Comment.js